<style>
/*.thisTbl th + th { border-left:1px solid #dddddd; }*/
.thisTbl th {
  border-left: 1px solid #dddddd;
}

.thisTbl td {
  border-left: 1px solid #dddddd;
}

/*.thisTbl td + td { border-left:1px solid #dddddd; }*/
</style>
<template>
  <v-card class="mx-auto mb-3">

    <div id="filters">
      <template>
        <v-toolbar flat>
          <v-toolbar-title>
            <p class="mb-0">{{ $t("STATISTIC_APP_NAME") }}</p>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-divider></v-divider>
        <v-form ref="form">
          <v-container>
            <v-row>
              <v-col class="ma-0" cols="12" lg="4" md="12" sm="12">
                <v-select
                    v-model="filterItems.appStatus"
                    :items="serverTranslateArray(status, 'name')"
                    :label="$t('APPLICATION_CASES')"
                    :rules="requiredRule"
                    clearable
                    item-text="name"
                    item-value="mongo_id"
                    multiple
                    outlined
                    small-chips
                >
                </v-select>
              </v-col>
              <v-col class="ma-0" cols="12" lg="4" md="12" sm="12" xs="12">
                <v-select
                    v-model="filterItems.yearId"
                    :items="serverTranslateArray(this.years, 'name')"
                    :label="$t('ACADEMIC_YEAR')"
                    clearable
                    item-text="name"
                    item-value="id"
                    outlined
                ></v-select>
              </v-col>
              <v-col class="ma-0" cols="12" lg="4" md="12" sm="12" xs="12">
                <v-select
                    v-model="filterItems.semesterId"
                    :items="serverTranslateArray(this.semesters, 'name')"
                    :label="$t('ACADEMIC_SEMESTER')"
                    clearable
                    item-text="name"
                    item-value="id"
                    outlined
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="ma-0" cols="12" lg="4" md="12" sm="12" xs="12">
                <v-select
                    v-model="filterItems.certificatesCategoryFilter"
                    :items="
                    serverTranslateArray(this.certificateCategoriesList, 'name')
                  "
                    :label="$t('CERTIFICATE')"
                    clearable
                    item-text="name"
                    item-value="id"
                    outlined
                    @change="selectCertType()"
                ></v-select>
              </v-col>

              <v-col class="ma-0" cols="12" lg="4" md="12" sm="12" xs="12">
                <v-select
                    v-model="filterItems.certificateTypeFilter"
                    :items="
                    serverTranslateArray(this.certificateTypesList, 'name')
                  "
                    :label="$t('SPECIALIZATION')"
                    clearable
                    item-text="name"
                    item-value="id"
                    multiple
                    outlined
                ></v-select>
              </v-col>
            </v-row>


            <v-row>
              <v-col class="ma-0" cols="12" lg="6" md="6" sm="6">
                <v-menu
                    v-model="startDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    min-width="290px"
                    offset-y
                    transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="startApplicationDate"
                        :label="$t('APPLY_APPLICATION_DATE') +$t('FROM')"
                        :rules="startDateRules"
                        clearable
                        prepend-icon="event"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="startApplicationDate"
                      :max="maxDate"
                      :min="minDate"
                      @input="startDateMenu = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="ma-0" cols="12" lg="6" md="6" sm="6">
                <v-menu
                    v-model="endDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    min-width="290px"
                    offset-y
                    transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        ref="endDate"
                        v-model="endApplicationDate"
                        :label="$t('APPLY_APPLICATION_DATE') +$t('TO')"
                        :rules="endDateRules"
                        clearable
                        prepend-icon="event"
                        readonly
                        v-bind="attrs"
                        v-on="on"

                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="endApplicationDate"
                      :max="maxDate"
                      :min="minDate"
                      @input="endDateMenu = false"></v-date-picker>
                </v-menu>
              </v-col>

            </v-row>


            <v-card-actions class="pa-0">
              <v-container class="px-0">
                <v-row>
                  <v-spacer></v-spacer>
                  <v-col class="pa-1" cols="auto">
                    <v-btn
                        :fab="!$vuetify.breakpoint.mdAndUp"
                        :small="!$vuetify.breakpoint.mdAndUp"
                        color="primary"
                        dark
                        @click="initializeList"

                    >
                      <span v-if="$vuetify.breakpoint.mdAndUp">{{
                          $t("VIEW")
                        }}</span>
                      <v-icon :right="$vuetify.breakpoint.mdAndUp"
                      >mdi-account-search
                      </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col class="pa-1 mx-2" cols="auto">
                    <v-btn
                        :fab="!$vuetify.breakpoint.mdAndUp"
                        :small="!$vuetify.breakpoint.mdAndUp"
                        class="white--text"
                        color="darken3"
                        @click="reset"
                    >
                      <span v-if="$vuetify.breakpoint.mdAndUp">{{
                          $t("RESET")
                        }}</span>
                      <v-icon :right="$vuetify.breakpoint.mdAndUp"
                      >mdi-delete-empty
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <!-- print button  -->
                <v-row>
                  <v-col class="pa-1 mx-2 " cols="auto">
                    <v-btn
                        :fab="!$vuetify.breakpoint.mdAndUp"
                        :small="!$vuetify.breakpoint.mdAndUp"
                        class="white--text"
                        color="darken3"
                        @click="print"
                    >
                      <span v-if="$vuetify.breakpoint.mdAndUp">{{
                          $t("PRINT")
                        }}</span>

                      <v-icon :right="$vuetify.breakpoint.mdAndUp"
                      >mdi-domain
                      </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col class="pa-1 mx-2 ma-0" cols="auto">
                    <v-checkbox v-model="showChart" :label="$t('SHOW_CHART')"></v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-actions>
          </v-container>
        </v-form>
      </template>

      <!-- start table -->
      <v-card class="mx-auto">
        <v-toolbar v-if="$vuetify.breakpoint.mdAndUp" flat>
          <v-row>
            <v-col class="pt-10" cols="12" lg="8" md="8">
              <v-toolbar-title
                  :class="!$vuetify.breakpoint.mdAndUp ? 'text-thin' : ''"
              >
                {{ $t(STATISTIC_APP_NAME) }}
              </v-toolbar-title>
            </v-col>

          </v-row>
        </v-toolbar>
        <v-row v-else>
          <v-col class="pb-0 ps-6" cols="12" lg="8" md="8">
            <v-toolbar-title
                :class="!$vuetify.breakpoint.mdAndUp ? 'text-thin' : ''"
            >
              {{ $t(STATISTIC_APP_NAME) }}
            </v-toolbar-title>
          </v-col>
          <!-- <v-col cols="12" md="4" lg="4">
            <v-select
              class="ma-3 pt-4 mb-0"
              v-model="value"
              :items="headers"
              :label="$t('HIDE_SHOW_COLUMN')"
              :placeholder="$t('HIDE_SHOW_COLUMN')"
              multiple
              append-outer-icon="mdi-filter"
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text caption"
                  >(+{{ value.length - 1 }} {{ $t("OTHER") }})</span
                >
              </template>
            </v-select>
          </v-col> -->
        </v-row>
        <!--  i want add total for date table-->
        <v-row v-if="$vuetify.breakpoint.mdAndUp">
          <v-col class="pa-0" cols="12">
            <v-card-text>
              <v-row class="d-flex justify-center">
                <v-col class="text-center" cols="12" lg="6" md="6">
                  {{ $t("TOTAL") }}: {{ total }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-col>
        </v-row>

        <!-- table -->
        <v-data-table
            id="app"
            ref="printableTable"
            :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-arrow-left',
            nextIcon: 'mdi-arrow-right',
            itemsPerPageOptions: [5, 10, 15, 50, 100]
          }"
            :headers="filteredFields"
            :hide-default-footer="true"
            :items="serverTranslateArrayKeys(filteredDataItems,['facultyName'])"
            :items-per-page="10"
            :loading="loading"
            :options.sync="appOptions"
            :server-items-length="total"
            class="elevation-1 thisTbl "
        >
          <!-- Table Body -->
          <template #body.append>
            <tr>
              <td><strong>{{ $t("TOTAL_ALL_COLUMNS") }}</strong></td>
              <td
                  v-for="header in filteredFields.slice(1)" :key="header.value"
                  class="text-right"
              >
                {{ calculateColumnTotal(header.value) }}
              </td>
            </tr>
          </template>
          <template v-slot:no-data>
            <v-alert class="mt-2" color="light5" icon="warning">
              {{ $t("NO_DATA") }}
            </v-alert>
          </template>
          <template v-slot:footer.page-text="props">
            {{ props.pageStart }} - {{ props.pageStop }} {{ $t("PAGE_TEXT") }}
            {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-card>


      <div v-if="showChart">
        <multi-bar-chart ref="chart" :chart-data="chartData"></multi-bar-chart>
      </div>


    </div>

  </v-card>


</template>

<script>
import serverTranslationsMixin from "@/mixins/serverTranslations.ts";
import globalMethodsMixin from "@/mixins/globalMethods";
import Validations from "@/components/shared/validations";
import ConfirmDialog from "@/components/shared/ConfirmDialog";
import MultiBarChart from '@/components/shared/MultiBarChart'

const statusToFieldMap = {
  "0": "draft",
  "1": "underReview",
  "2": "acceptedCount",
  "3": "refusedCount",
  "4": "incomplete",
  "5": "recommendedAccepted",
  "6": "recommendedRefused",
  "7": "underReview",
  //   "7": "underReviewWithoutFees",
  "8": "pulledToSIS",
  "9": "refusedAsAcceptedInOther",
  "10": "waitingList",
};
export default {
  mixins: [serverTranslationsMixin, globalMethodsMixin],
  components: {"multi-bar-chart": MultiBarChart},
  data() {
    return {
      appOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
      },
      startDateMenu: false,
      endDateMenu: false,
      startApplicationDate: "",
      endApplicationDate: "",
      loading: false,
      showChart: false,
      dataItems: [],
      total: 0,
      requiredRule: Validations.required(),
      filterItems: {
        yearId: this.$store.getters.getActiveAcademicYear.id,
        yearName: this.$store.getters.getActiveAcademicYear.name,
        semesterId: this.$store.getters.getActiveAcademicSemester.id,
        semesterName: this.$store.getters.getActiveAcademicSemester.name || 0,
        appStatus: "",
        appStatusName: "",
        certificatesCategoryFilter: "",
        certificateTypeFilter: ""
      },
      semesters: [],
      years: [],
      faculties: [],
      statusApp: [],
      certificateCategoriesList: [],
      certificateTypesList: [],
      currentYear: {},
      currentSemester: {},
      value: [],
      chartData: {
        labels: [],
        datasets: []
      },


    };
  },


  computed: {
    endDateRules() {
      return [
        v =>
            new Date(this.endApplicationDate) >= new Date(this.startApplicationDate) ||
            this.$t("DATE_FROM_TO_VALIDATION")
      ]
    },
    startDateRules() {
      return [
        v => !this.endApplicationDate || new Date(v) <= new Date(this.endApplicationDate) || this.$t("DATE_FROM_TO_VALIDATION")

      ];
    },

    activeAcademicYear() {
      return this.$store.getters.getActiveAcademicYear;
    },
    activeAcademicSemester() {
      return this.$store.getters.getActiveAcademicSemester;
    },

    headers() {
      const fields = [
        {
          id: 0,
          text: this.$t("FACULTY"),
          align: "start",
          sortable: true,
          value: "facultyName",
          width: "300px"
        },
        {
          id: 1,
          text: this.$t("COUNT_ACCEPTED_STUDENTS"),
          align: "start",
          sortable: true,
          value: "acceptedCount"
        },
        {
          id: 2,
          text: this.$t("COUNT_REFUSED_STUDENTS"),
          align: "start",
          sortable: true,
          value: "refusedCount"
        },
        {
          id: 3,
          text: this.$t("RECOMMENDED_ACCEPTED"),
          align: "start",
          sortable: true,
          value: "recommendedAccepted"
        },
        {
          id: 4,
          text: this.$t("RECOMMENDED_REFUSED"),
          align: "start",
          sortable: true,
          value: "recommendedRefused"
        },
        {
          id: 5,
          text: this.$t("COUNT_DRAFT_STUDENTS"),
          align: "start",
          sortable: true,
          value: "draft"
        },
        {
          id: 6,
          text: this.$t("COUNT_UNDER_REVIEW_STUDENTS"),
          align: "start",
          sortable: true,
          value: "underReview"
        },
        /*   {
            id: 7,
            text: this.$t("COUNT_UNDER_REVIEW_NOFEES_STUDENTS"),
            align: "start",
            sortable: false,
            value: "underReviewWithoutFees"
          }, */
        {
          id: 8,
          text: this.$t("COUNT_PULLED_SIS_STUDENTS"),
          align: "start",
          sortable: true,
          value: "pulledToSIS"
        },
        {
          id: 9,
          text: this.$t("COUNT_REFUSED_AS_ACCEPTED_IN_OTHER_STUDENTS"),
          align: "start",
          sortable: true,
          value: "refusedAsAcceptedInOther"
        },
        {
          id: 10,
          text: this.$t("COUNT_WAITING_LIST_STUDENTS"),
          align: "start",
          sortable: true,
          value: "waitingList"
        },
        {
          id: 11,
          text: this.$t("COUNT_INCOMPLETE_STUDENTS"),
          align: "start",
          sortable: true,
          value: "incomplete"
        },
        {
          id: 12,
          text: this.$t("OVER_ALL_COUNT_STUDENT"),
          align: "start",
          sortable: false,
          value: "allCount"
        }
      ];
      return fields;
    },

    selectedHeaders: {
      get() {
        const item = this.sortByKey(this.value, "id");
        return this.value.length > 0 &&
        this.value.length !== this.headers.length
            ? item
            : this.headers;
      },
      set(value) {
        this.value.forEach(element => {
          if (element.id === this.headers[element.id].id) {
            element.text = this.headers[element.id].text;
          }
        });
      }
    },
    filteredFields() {
      if (this.filterItems.appStatus.length === 0) {
        return this.selectedHeaders;
      }


      let selectedFieldIds = ["facultyName"]; // Always include the faculty name field
      this.filterItems.appStatus.forEach(statusItem => {
        if (Array.isArray(statusItem)) {
          statusItem.forEach(status => {
            if (statusToFieldMap[status]) {
              selectedFieldIds = selectedFieldIds.concat(statusToFieldMap[status]);
            }
          });
        } else {
          // If statusItem is a single status code, handle it directly
          if (statusToFieldMap[statusItem]) {
            selectedFieldIds = selectedFieldIds.concat(statusToFieldMap[statusItem]);
          }
        }

      });

      if (this.filterItems.appStatus.length > 1) {
        selectedFieldIds.push("allCount");
      }
      return this.selectedHeaders.filter(field => selectedFieldIds.includes(field.value));
    },

    filteredDataItems() {
      const dataItemsTranslate = (this.dataItems)

      if (this.filterItems.appStatuslength === 0) {
        return dataItemsTranslate;
      }
      return dataItemsTranslate.map(item => {
        // i want add total for every column
        const filteredItem = {};
        this.filteredFields.forEach(field => {
          if (item[field.value]) {
            filteredItem[field.value] = item[field.value];
          }
        });
        let selectedFields = [];
        if (Array.isArray(this.filterItems.appStatus) && this.filterItems.appStatus.length > 1) {
          selectedFields = [...new Set(
              this.filterItems.appStatus
                  .flat()
                  .map(status => statusToFieldMap[status])
                  .filter(field => field)
          )];
        } else {
          selectedFields = [...new Set(Object.values(statusToFieldMap))];
        }
        filteredItem.allCount = selectedFields.reduce((sum, field) => sum + (parseInt(item[field]) || 0), 0);
        return filteredItem;
      });
    },
    direction: function () {
      return this.$store.state.direction;
    }
  },
  watch: {
    direction: function () {
      this.selectedHeaders = this.value;
    },
    filteredDataItems(newItems) {
      this.updateChartData(newItems);
    },
    appOptions: {
      handler() {
        this.initializeList();
      },
      deep: true
    }
  }
  ,
  mounted() {
    this.getFilters();
    this.initializeList();
    this.value = this.headers;
  }
  ,
  methods: {

    print() {

      const tableHTML = this.$refs.printableTable.$el;

      // Get the HTML element for the chart, if available
      const chartImage = this.$refs.chart ? this.$refs.chart.getBase64Image() : '';

      // Call the printTable function with the HTML content of the table and optionally the chart
      this.printTable(tableHTML, chartImage, this.direction);

    }
    ,
    reset() {
      this.filterItems.yearId = this.activeAcademicYear.id;
      this.filterItems.semesterId = this.activeAcademicSemester.id;
      this.filterItems.appStatus = ""
      this.filterItems.certificatesCategoryFilter = ""
      this.filterItems.certificateTypeFilter = "",
          this.startApplicationDate = "",
          this.endApplicationDate = ""
    }
    ,
    calculateColumnTotal(field) {
      let total = 0;
      const items = this.serverTranslateArrayKeys(this.filteredDataItems, ['facultyName']);
      for (const item of items) {
        const value = Number(item[field]);
        if (!isNaN(value)) {
          total += value;
        }
      }
      return total !== 0 ? total : ''; // Show blank if no numeric total
    }
    ,
    getFilters(facultyId = null) {
      return this.$http
          .post("/api/students_admission_apps/list_application_filters/", {
            facultyId: facultyId || "",
            yearId: this.activeAcademicYear.id || 0,
            semesterId: this.activeAcademicSemester.id || 0
          })
          .then(
              response => {
                const data = response.data.data;
                this.semesters = data.Semesters;
                this.years = data.years;
                this.status = data.applicationStatus;
                this.statusApp = data.applicationStatus
                //this.status = data.applicationStatus.includes(',') ? data.applicationStatus.split(',') : data.applicationStatus;
                this.faculties = data.faculties;
                this.certificateCategoriesList =
                    data.certificateCategories["basic_category_items"];
                this.currentYear = this.years.filter(
                    year => parseInt(year.active) === 1
                )[0];
                this.filterItems.yearId = this.currentYear.id || 0;
                this.filterItems.yearName = this.currentYear.name || "";
                this.currentSemester = this.semesters.filter(
                    semester => parseInt(semester.active) === 1
                )[0];
                this.filterItems.semesterId = this.currentSemester.id || 0;
                this.filterItems.semesterName = this.currentSemester.name || "";
              },
              err => {
                this.showToasted("error", err.response.data.message);
              }
          )
          .then(() => (this.loading = false));
    }
    ,

    selectCertType() {
      return this.$http
          .post("/api/students_admission_apps/get_certificate_type_filter/", {
            categoryId: this.filterItems.certificatesCategoryFilter || 0
          })
          .then(
              response => {
                const data = response.data.data;
                this.certificateTypesList =
                    data.certificatesTypes["basic_category_items"];
              },
              err => {
                this.showToasted("error", err.response.data.message);
              }
          )
          .then(() => (this.loading = false));
    }
    ,
    initializeList() {
      this.loading = true;
      return this.$http
          .post("/api/students_admission_apps/get_general_statistic/", {
            semesterId: this.filterItems.semesterId,
            yearId: this.filterItems.yearId,
            appStatus: (
                this.filterItems.appStatus && Array.isArray(this.filterItems.appStatus)
                    ? this.filterItems.appStatus.flat()
                    : ""
            ),
            certificateCategoryId: this.filterItems.certificatesCategoryFilter,
            certificateTypeId: this.filterItems.certificateTypeFilter,
            startApplicationDate: this.startApplicationDate,
            endApplicationDate: this.endApplicationDate,
          })
          .then(
              (response) => {
                const resultData = response.data.data;
                resultData.forEach((item) => {
                    Object.keys(item).forEach((key) => {
                      if (Array.isArray(item[key]) && item[key].length === 1) {
                        item[key] = item[key][0];
                      }
                    });
                  });
                // Apply sorting manually
                const sortBy = this.appOptions.sortBy?.[0] || null;
                const sortDesc = this.appOptions.sortDesc?.[0] || false;

                if (sortBy) {
                    resultData.sort((a, b) => {
                      const unwrap = (val) => {
                        if (Array.isArray(val)) return val[0]; // unwrap [3] to 3
                        return val ?? ""; // fallback for null/undefined
                      };

                      const aVal = unwrap(a[sortBy]);
                      const bVal = unwrap(b[sortBy]);

                      if (typeof aVal === "number" && typeof bVal === "number") {
                        return sortDesc ? bVal - aVal : aVal - bVal;
                      }

                      const aStr = aVal.toString().toLowerCase();
                      const bStr = bVal.toString().toLowerCase();
                      return sortDesc ? bStr.localeCompare(aStr) : aStr.localeCompare(bStr);
                    });
                  }
                this.dataItems = resultData;
                this.total = this.dataItems.length;
              },
              (err) => {
                this.showToasted("error", err.response.data.message);
              }
          )
          .finally(() => {
            this.loading = false;
          });
    }
    ,
    updateChartData(items) {
      const labels = items.map(item => this.serverTranslate(item.facultyName) || '');
      const draft = items.map(item => item.draft ? item.draft : 0);
      const acceptedCount = items.map(item => item.acceptedCount ? item.acceptedCount : 0);
      const refusedCount = items.map(item => item.refusedCount ? item.refusedCount : 0);
      const incomplete = items.map(item => item.incomplete ? item.incomplete : 0);
      const recommendedAccepted = items.map(item => item.recommendedAccepted ? item.recommendedAccepted : 0);
      const recommendedRefused = items.map(item => item.recommendedRefused ? item.recommendedRefused : 0);
      const pulledToSIS = items.map(item => item.pulledToSIS ? item.pulledToSIS : 0);
      const underReview = items.map(item => item.underReview ? item.underReview : 0);
      const refusedAsAcceptedInOther = items.map(item => item.refusedAsAcceptedInOther ? item.refusedAsAcceptedInOther : 0);
      const waitingList = items.map(item => item.waitingList ? item.waitingList : 0);
      const allCount = items.map(item => item.allCount ? item.allCount : '')

      this.chartData = {
        labels,
        datasets: [
          {
            label: this.$t("DRAFT_STATUS"),
            backgroundColor: 'rgba(248, 121, 121, 0.6)', // lighter red
            data: draft
          },
          {
            label: this.$t("ACCEPTED_STATUS"),
            backgroundColor: 'rgba(122, 203, 245, 0.6)', // lighter blue
            data: acceptedCount
          },
          {
            label: this.$t("REFUSED_STATUS"),
            backgroundColor: 'rgba(122, 203, 213, 0.6)', // lighter green
            data: refusedCount
          },
          {
            label: this.$t("TO_BE_COMPLETED"),
            backgroundColor: 'rgba(122, 255, 213, 0.6)', // lighter green-blue
            data: incomplete
          },
          {
            label: this.$t("RECOMMENDED_ACCEPTED_STATUS"),
            backgroundColor: 'rgba(165, 86, 105, 0.6)', // lighter purple
            data: recommendedAccepted
          },
          {
            label: this.$t("RECOMMENDED_REFUSED_STATUS"),
            backgroundColor: 'rgba(253, 195, 0, 0.6)', // lighter yellow
            data: recommendedRefused
          },
          {
            label: this.$t("UNDER_REVIEW_STATUS"),
            backgroundColor: 'rgba(102, 187, 106, 0.6)', // lighter light-green
            data: underReview
          },
          {
            label: this.$t("REFUSED_AS_ACCEPTED_IN_OTHER_STUDENTS"),
            backgroundColor: 'rgb(155,0,253)', // lighter sky-blue
            data: refusedAsAcceptedInOther
          },
          {
            label: this.$t("WAITING_LIST"),
            backgroundColor: 'rgba(58,215,215)', // lighter sky-blue
            data: waitingList
          },
          {
            label: this.$t("PULLED_TO_SIS_STATUS"),
            backgroundColor: 'rgba(255, 138, 70, 0.6)', // lighter orange
            data: pulledToSIS
          },
          /*    {
               label: this.$t("ALL_COUNT_STUDENT"), // label for allCount
               backgroundColor: 'rgba(183, 193, 172)',
               data: allCount
             } */

        ]
      }
    }
    ,

  }
}
;
</script>
